let launchOverlayEl = null;
let dataAreaModalApi = null;

function showPlatformLaunchOverlay() {
  if (launchOverlayEl) return;
  const el = document.createElement('div');
  el.className = 'platform-launch-overlay';
  el.setAttribute('role', 'status');
  el.setAttribute('aria-live', 'polite');
  el.innerHTML = '<div class="platform-launch-overlay-card"><span class="spin platform-launch-spinner" aria-hidden="true"></span><span>Opening platform…</span></div>';
  document.body.appendChild(el);
  launchOverlayEl = el;
}

function hidePlatformLaunchOverlay() {
  if (!launchOverlayEl) return;
  launchOverlayEl.remove();
  launchOverlayEl = null;
}

/**
 * Register a React modal host for multi-DataArea selection.
 * @param {(payload: { tool: object, options: Array<{dataAreaId:string,url:string}>, onPick: (opt)=>void, onCancel: ()=>void } | null) => void} openFn
 */
export function registerDataAreaLaunchModal(openFn) {
  dataAreaModalApi = typeof openFn === 'function' ? openFn : null;
  return () => {
    if (dataAreaModalApi === openFn) dataAreaModalApi = null;
  };
}

function pickDataAreaOption(tool, options) {
  return new Promise((resolve) => {
    if (typeof dataAreaModalApi !== 'function') {
      resolve(options[0] || null);
      return;
    }
    dataAreaModalApi({
      tool,
      options,
      onPick: (option) => resolve(option || null),
      onCancel: () => resolve(null),
    });
  });
}

export function getPlatformScreenshotSources(tool) {
  const key = String(tool?.key || '').trim().toLowerCase();
  if (!key) return null;
  return {
    primary: `/platform-screenshots/${encodeURIComponent(key)}.jpg`,
    fallback: '/platform-screenshots/_default.jpg',
  };
}

export function getPlatformLogoSources(tool) {
  const fromApi = String(tool?.logoUrl || '').trim();
  if (fromApi) {
    return {
      primary: fromApi,
      fallback: '/platform-logos/_default.png',
    };
  }

  const key = String(tool?.key || '').trim().toLowerCase();
  if (!key) return null;
  return {
    primary: `/platform-logos/${encodeURIComponent(key)}.png`,
    fallback: '/platform-logos/_default.png',
  };
}

function normalizeLaunchUrl(raw) {
  const rawUrl = String(raw || '').trim();
  if (!rawUrl) return '';
  if (!rawUrl.startsWith('http://') && !rawUrl.startsWith('https://') && !rawUrl.startsWith('/')) {
    return `/${rawUrl}`;
  }
  return rawUrl;
}

function getToolDataAreaOptions(tool) {
  const rows = Array.isArray(tool?.dataAreaUrls) ? tool.dataAreaUrls : [];
  return rows
    .map((row) => ({
      dataAreaId: String(row?.dataAreaId || row?.DataAreaId || '').trim(),
      url: String(row?.url || row?.Url || '').trim(),
    }))
    .filter((row) => row.dataAreaId && row.url);
}

async function launchExternalUrl(tool, url) {
  const platformCode = String(tool?.key || '').trim().toLowerCase();
  const isHkClaim = /hkclaim/i.test(String(tool?.key || '')) || /hk\s*claim/i.test(String(tool?.name || ''));
  const ssoPlatform = platformCode || (isHkClaim ? 'hkclaim' : '');
  if (ssoPlatform) {
    showPlatformLaunchOverlay();
    window.location.assign(`/api/sso/start?platform=${encodeURIComponent(ssoPlatform)}&returnUrl=${encodeURIComponent(url)}`);
    return true;
  }
  window.location.assign(url);
  return true;
}

export async function openPlatformTool(tool, navigate) {
  if (!tool) return false;

  const options = getToolDataAreaOptions(tool);
  let chosenUrl = '';

  if (options.length > 1) {
    const picked = await pickDataAreaOption(tool, options);
    if (!picked) {
      return false;
    }
    chosenUrl = normalizeLaunchUrl(picked.url);
  } else if (options.length === 1) {
    chosenUrl = normalizeLaunchUrl(options[0].url);
  } else {
    chosenUrl = normalizeLaunchUrl(tool.url);
  }

  if (!chosenUrl) {
    return false;
  }

  if (chosenUrl.startsWith('http://') || chosenUrl.startsWith('https://')) {
    return launchExternalUrl(tool, chosenUrl);
  }

  hidePlatformLaunchOverlay();
  if (typeof navigate === 'function') {
    navigate(chosenUrl);
    return true;
  }

  window.location.assign(chosenUrl);
  return true;
}
